module.exports = __webpack_public_path__ + "static/media/Synthomer.8227a300.webp";